/**
 * BDPriceLadder — convert a pound amount into a price-point variant.
 * Money in, variant out. No material costs, rates, delivery or markup.
 */
(function (window) {
  'use strict';

  var TARGET_BANDS = [
    { max: 100, step: 10 },
    { max: 200, step: 2 },
    { max: 500, step: 4 },
    { max: 1000, step: 10 },
    { max: 2000, step: 20 },
    { max: 5000, step: 40 },
    { max: 10000, step: 100 },
    { max: 20000, step: 200 },
    { max: 40000, step: 400 },
    { max: Infinity, step: 500 }
  ];

  function bandsTruncatedAtCap(cap) {
    var out = [];
    var i;
    var b;
    for (i = 0; i < TARGET_BANDS.length; i++) {
      b = TARGET_BANDS[i];
      if (b.max < cap) {
        out.push({ max: b.max, step: b.step });
      } else if (b.max === cap) {
        out.push({ max: b.max, step: b.step });
        break;
      } else {
        out.push({ max: cap, step: b.step });
        break;
      }
    }
    return out;
  }

  function targetProfile(name, cap, prefix) {
    return {
      name: name,
      bands: bandsTruncatedAtCap(cap),
      cap: cap,
      floor: 10,
      prefix: prefix
    };
  }

  var PROFILES = {
    target_mfc: targetProfile('target_mfc', 50000, 'BD_MFC_'),
    target_cgl: targetProfile('target_cgl', 50000, 'BD_CGL_'),
    target_c16: targetProfile('target_c16', 10000, 'BD_C16_'),
    target_lam_tt: targetProfile('target_lam_tt', 50000, 'BD_LAM_TT_'),
    target_cgl_tt: targetProfile('target_cgl_tt', 5000, 'BD_CGL_TT_'),
    target_shelves: targetProfile('target_shelves', 5000, 'BD_SHV_'),
    target_door: targetProfile('target_door', 4500, 'BD_DOOR_'),
    target_pil: targetProfile('target_pil', 4500, 'BD_PIL_'),
    target_pilaster: targetProfile('target_pilaster', 4500, 'BD_PIL_'),
    target_part: targetProfile('target_part', 4500, 'BD_PART_'),
    target_partition: targetProfile('target_partition', 4500, 'BD_PART_'),
    target_postformed: targetProfile('target_postformed', 50000, 'BD_PF_'),
    target_ips_mfc: targetProfile('target_ips_mfc', 50000, 'BD_IPS_MFC_'),
    target_ips_mrmdf: targetProfile('target_ips_mrmdf', 50000, 'BD_IPS_MRMDF_'),
    target_ips_cgl: targetProfile('target_ips_cgl', 50000, 'BD_IPS_CGL_'),
    target_lgw: targetProfile('target_lgw', 50000, 'BD_LGW_'),
    target_ckw: targetProfile('target_ckw', 50000, 'BD_CKW_')
  };

  function getProfile(name) {
    var profile = PROFILES[name];
    if (!profile) {
      throw new Error('BDPriceLadder.getProfile: unknown profile "' + name + '"');
    }
    return profile;
  }

  function roundToRung(pounds, profile) {
    if (!profile || !profile.bands || !profile.bands.length) {
      throw new Error('BDPriceLadder.roundToRung: profile.bands is required');
    }
    var amount = Number(pounds);
    if (!isFinite(amount)) {
      throw new Error('BDPriceLadder.roundToRung: pounds must be a finite number');
    }
    var bands = profile.bands;
    var step = bands[bands.length - 1].step;
    var i;
    for (i = 0; i < bands.length; i++) {
      if (amount <= bands[i].max) {
        step = bands[i].step;
        break;
      }
    }
    return Math.round(amount / step) * step;
  }

  function loadMap(url) {
    return fetch(url).then(function (res) {
      if (!res.ok) {
        throw new Error('BDPriceLadder.loadMap: HTTP ' + res.status);
      }
      return res.json();
    });
  }

  function resolve(opts) {
    opts = opts || {};
    var pounds = opts.pounds;
    var profile = opts.profile;
    var map = opts.map || {};

    if (pounds > profile.cap) {
      return { ok: false, rung: null, key: null, variantId: null, reason: 'over_cap' };
    }

    var rung = roundToRung(pounds, profile);
    rung = Math.min(rung, profile.cap);
    rung = Math.max(rung, profile.floor);

    var key = profile.prefix + rung + '_CP';
    var variantId = map[key];
    if (variantId == null || variantId === '') {
      return { ok: false, rung: rung, key: key, variantId: null, reason: 'no_variant' };
    }

    return { ok: true, rung: rung, key: key, variantId: variantId, reason: null };
  }

  window.BDPriceLadder = {
    getProfile: getProfile,
    roundToRung: roundToRung,
    loadMap: loadMap,
    resolve: resolve
  };
})(window);
